import type { LineItem } from '@pperform/pp-data-mappers';
import { numberFormatter } from '@pperform/pp-utils/numberFormatters';
import type { Configs as PtpConfig } from 'interfaces/WidgetConfigs.interface';

const getDisplayPrice = (lineItem: LineItem): string => {
  const { totalPrice, currencyCode } = lineItem;

  return totalPrice && currencyCode
    ? `${numberFormatter(totalPrice)} ${currencyCode}`
    : '-';
};

const getDisplayQuantity = (lineItem: LineItem): number | string => {
  return lineItem.quantity ? `${lineItem.quantity}x` : '-';
};

const getDisplayProductDescription = (lineItem: LineItem): string => {
  return lineItem.productDescription || '-';
};

const getDisplayProductImageUrl = (
  lineItem: LineItem,
  ptpConfig: PtpConfig,
): string => {
  return (
    lineItem.productImageUrl ||
    lineItem.productImageOriginalUrl ||
    ptpConfig.lineItem.noImageAvailableIcon
  );
};

const getProductID = (lineItem: LineItem): string => {
  return lineItem.productId || '-';
};

const getDisplayCustomReturnReason = (lineItem: LineItem): string => {
  let reason = lineItem.returnReason;
  if (lineItem.additionalInfo?.returnReasonEngDesc)
    reason = lineItem.additionalInfo?.returnReasonEngDesc;
  return reason || '-';
};

export {
  getDisplayPrice,
  getDisplayQuantity,
  getDisplayProductDescription,
  getDisplayProductImageUrl,
  getProductID,
  getDisplayCustomReturnReason,
};
